import {
  Analytics as AnalyticsIcon,
  AssessmentOutlined as AssessmentIcon,
  Dashboard as DashboardIcon,
  Psychology as PsychologyIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
  Storage as DatasetIcon,
  TrendingUp as TrendingUpIcon,
  Visibility as VisibilityIcon
} from "@mui/icons-material";

export interface NavigationItem {
  title: string;
  path: string;
  icon: typeof DashboardIcon;
  requiredRole?: "admin" | "member";
  featureFlag?: string;
}

export const navigationConfig: NavigationItem[] = [
  {
    title: "Manager Hub",
    path: "/",
    icon: PsychologyIcon,
    featureFlag: "coaching"
  },
  {
    title: "Performance Analysis",
    path: "/performance-analysis",
    icon: TrendingUpIcon,
    featureFlag: "performance-analysis-dashboard"
  },
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: DashboardIcon
  },
  {
    title: "Call Explorer",
    path: "/explore",
    icon: SearchIcon
  },
  {
    title: "Performance",
    path: "/performance",
    icon: AssessmentIcon,
    featureFlag: "performance-dashboard"
  },
  {
    title: "Lens Library",
    path: "/lens-library",
    icon: VisibilityIcon,
    requiredRole: "admin",
    featureFlag: "aha-lens-admin"
  },
  {
    title: "Datasets",
    path: "/datasets",
    icon: DatasetIcon,
    featureFlag: "batch-lens-testing"
  },
  {
    title: "Analysis Configuration",
    path: "/account-analysis",
    icon: AnalyticsIcon,
    requiredRole: "admin",
    featureFlag: "account-analysis-configuration"
  },
  {
    title: "Account Settings",
    path: "/account-settings",
    icon: SettingsIcon,
    requiredRole: "admin",
    featureFlag: "account-settings"
  }
];
